<template>
  <BittsTooltip
    v-if="actionText"
    placement="bottom"
    data-testid="api-card-action-tooltip"
  >
    <BittsButton
      :text="actionText"
      type="neutral"
      variant="outline"
      size="small"
      :left-icon="actionIcon"
      :disabled="!!actionDisabledReason"
      @click="emit('action')"
    />
    <template v-if="actionDisabledReason" #title>
      {{ actionDisabledReason }}
    </template>
  </BittsTooltip>
  <BittsDropdownMenu
    v-if="menuOptions.length"
    :options="menuOptions"
    mode="single"
    :use-search="false"
    @item-click="handleMenuClick"
  >
    <BittsButton
      type="neutral"
      variant="outline"
      size="small"
      :center-icon="['fas', 'ellipsis']"
      :aria-label="`More actions for ${resourceName}`"
    />
  </BittsDropdownMenu>
</template>

<script setup lang="ts">
import { BittsButton, BittsDropdownMenu, BittsTooltip } from '@crossbeam/bitts';
import type { BittsIcon } from '@crossbeam/bitts';

import type { ApiCardMenuOptionType } from '../types';

const {
  actionText = '',
  actionIcon = undefined,
  actionDisabledReason = '',
  menuOptions = [],
} = defineProps<{
  actionText?: string;
  actionIcon?: BittsIcon;
  actionDisabledReason?: string;
  resourceName: string;
  menuOptions?: ApiCardMenuOptionType[];
}>();

const emit = defineEmits<{
  action: [];
  'menu-select': [value: string];
}>();

function handleMenuClick(option: ApiCardMenuOptionType, event: MouseEvent) {
  event.preventDefault();
  emit('menu-select', option.value);
}
</script>
